import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyCoinPound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.6 16.109a4.28 4.28 0 0 1-3.564 0 4.28 4.28 0 0 0-3.565.356 2.14 2.14 0 0 0 1.426-1.782V9.337a2.851 2.851 0 0 1 5.31-1.426m-1.817 4.277H8.4M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 0 1 19.2 0"
    />
  </svg>
);
export default SvgCurrencyCoinPound;
